import React from "react";

// Components
import ContentCard from "../../../../UI/ContentCard/ContentCard";

// Images
import fitImg from "../../../../assests/images/fit.png";

const ConceptPerfectFit = () => (
  <ContentCard
    title="The Perfect Fit"
    id="Customize your clothes"
    image={fitImg}
    imageTitle="THE MODEL IN FIVE STEPS"
    frontText="We have created a size scale that will fit you like tailor-made"
    backTextOne="We have created a size scale that takes the different body shapes into account and is, on todays market,
        the closest thing to the perfect fit without visiting a tailor."
    backTextTwo="To begin, measure one of your own garments that fits you best. You once enter the measurements in to your profile at
        SAMPELL and from then on simply design."
  />
);

export default ConceptPerfectFit;



// WEBPACK FOOTER //
// ./src/components/Pages/Concept/Content/ConceptPerfectFit.js